import './index.less';

import request from '@/utils/request';
import { getLocaleText, setSearchHistory } from '@/utils/utils';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import { Toast } from 'antd-mobile';
import md5 from 'js-md5';
import { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { getLocale, history } from 'umi';

import Verify from './Verify';

console.log(getLocale());

let timelock: any = null;
const Login = (props: any) => {
  const [verifyVisable, setVeryfiVisable] = useState(false);
  const [phone, setPhone] = useState<any>(null);
  const [erData, setErData] = useState<any>();
  const radioGroupRef = useRef<HTMLElement>(null);
  const intl = useIntl();

  // 关闭验证码弹窗
  const verifyClose = () => {
    setVeryfiVisable(false);
  };

  //二维码图片转码
  function base64ToImage(base64String: any) {
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'image/jpeg' });
    //  var arr = base64String.split(',')  //去掉base64格式图片的头部
    // 将上面这段改为下面这段代码
    //var bstr = atob(str);
    let url = URL.createObjectURL(blob); //创建URL
    return url;
  }

  // 获取二维码
  const getQR = async () => {
    clearInterval(timelock);
    timelock = null;
    const Url = `${process.env.BMSUrl}bms/user/ctmlogin/createEr`;
    const res = await request.post(Url, {
      data: {
        lang: `${getLocale().replace(/-/gi, '_')}`,
        version: 1,
      },
    });
    if (res?.code === 200) {
      setErData(res.data);

      checkQrLogin(res.data.uuid);
    } else {
      Toast.info(res?.mes);
    }
  };

  // 获取二维码
  useEffect(() => {
    getQR();
    return () => {
      clearInterval(timelock);
      timelock = null;
    };
  }, []);

  // 轮询扫码登陆
  const checkQrLogin = async (uuid: any) => {
    const check = async () => {
      const Url = `${process.env.BMSUrl}bms/user/ctmlogin/chechErLogin?&uuid=${uuid}&mac=1234567890`;
      const res = await request.post(Url, {
        data: {
          lang: `${getLocale().replace(/-/gi, '_')}`,
          version: 1,
        },
      });
      if (res?.code === 200) {
        clearInterval(timelock);
        timelock = null;
        Toast.info(
          intl.formatMessage({
            id: 'login.page.loginSuccess',
          }),
        );
        localStorage.setItem('accountId', res.data.accountId);
        localStorage.setItem('userId', res.data.userId);
        localStorage.setItem('userToken', res.data.userToken);
        localStorage.setItem('netType', res.data.netType);
        res.data.email && localStorage.setItem('ctmEmail', res.data.email);
        res.data.duCode && localStorage.setItem('duCode', res.data.duCode);

        synchronization();
        hmovdLogin();
      } else if (res?.code == 2001) {
        getQR();
      }
    };
    timelock = setInterval(check, 2000);
    setTimeout(() => {
      clearInterval(timelock);
      timelock = null;
    }, 180000);
  };

  // 校验澳门手机号
  function validateMacaoPhoneNumber(phoneNumber: any) {
    const macaoPhoneRegex = /^[6-8]\d{7}$/;
    return macaoPhoneRegex.test(phoneNumber);
  }
  // 去验证
  const verify = () => {
    const isValidPhoneNumber = validateMacaoPhoneNumber(phone);
    if (isValidPhoneNumber) {
      setVeryfiVisable(true);
      clearInterval(timelock);
      timelock = null;
    } else {
      Toast.info(
        intl.formatMessage({
          id: 'login.page.please',
        }),
      );
    }
  };
  // 鉴权同步
  const synchronization = async () => {
    const userTypeUrl = `${process.env.BMSUrl}bms/user/ctmlogin/checkCustomerReq?version=1`;
    const userTypeRes = await request.post(userTypeUrl, {
      data: {
        lang: `${getLocale().replace(/-/gi, '_')}`,
        accountId: phone,
        mac: `1234567890`,
        userId: localStorage.getItem('userId'),
        platformCode: `${process.env.BMSsiteId}`,
        userToken: localStorage.getItem('userToken'),
        ctmNumber: localStorage.getItem('duCode')
          ? localStorage.getItem('duCode')
          : phone,
      },
    });
    if (userTypeRes.code == 200) {
      localStorage.setItem('netType', userTypeRes.data.netType);
      const Url = `${process.env.BMSUrl}bms/pay/ctm/checkNewCTMProfileReq?version=1`;
      const res = await request.post(Url, {
        data: {
          accountId: phone,
          lang: `${getLocale().replace(/-/gi, '_')}`,
          userId: localStorage.getItem('userId'),
          platformCode: `${process.env.BMSsiteId}`,
          userToken: localStorage.getItem('userToken'),
          ctmNumber: localStorage.getItem('duCode')
            ? localStorage.getItem('duCode')
            : phone,
        },
      });
    }
  };
  function extractToken(str: any, regex: any) {
    const match = regex.exec(str); // 使用 exec 方法获取匹配结果
    if (match) {
      return match[1]; // 返回匹配的第一个捕获组
    } else {
      return null; // 如果没有匹配则返回 null
    }
  }
  const hmovdLogin = async () => {
    let params = `mobileno=${localStorage.getItem(
      'accountId',
    )}&rememberme=on&appVersion=1.0.31&osVersion=25&deviceModel=chrome&deviceSerial=1&network=wifi&language=zh_HK&platform=ctm&areaCode=853`;
    let decode = `${params}&secret=CTM6730454679509094068`;

    let sign = md5(decode);

    let loginURL = `${process.env.HMVODLogin}/ctmLogin.action?${params}&sign=${sign}`;

    let resLogin = await request.get(loginURL);
    const regex = /<token>(.*?)<\/token>/; // 匹配 <token> 和 </token> 之间的任意字符
    let token = await extractToken(JSON.stringify(resLogin), regex);
    localStorage.setItem('token', token);
    if (window.location.href.includes('/login')) {
      history.push({
        pathname: '/home',
      });
    } else {
      history.go(0);
    }
  };
  return (
    <div>
      <Dialog
        className="login"
        open={true}
        // onClose={handleClose}
        aria-labelledby="form-dialog-title"
        disableBackdropClick={true}
      >
        <div className="content">
          <div className="left">
            {' '}
            <DialogContent>
              <DialogContentText>
                {getLocaleText('login.page.phone')}
              </DialogContentText>
              <div className="phone">
                <span>+853</span>

                <TextField
                  value={phone}
                  autoFocus
                  margin="dense"
                  id="name"
                  onChange={(v) => setPhone(v.target.value)}
                  // label="Email Address"
                  // type="email"
                  fullWidth
                  // error
                  // helperText="Incorrect entry."
                />
              </div>
            </DialogContent>
            <DialogActions>
              <Button color="primary" onClick={verify}>
                {`${getLocaleText('login.page.verify')}>>`}
              </Button>
            </DialogActions>
          </div>
          <div className="right">
            {erData && (
              <img src={base64ToImage(erData?.erCode)} alt="" onClick={getQR} />
            )}
          </div>
        </div>
      </Dialog>
      {verifyVisable && (
        <Verify visable={verifyVisable} close={verifyClose} phone={phone} />
      )}
    </div>
  );
};

export default Login;
